import axios from 'axios';

export const deleteTagsMap = async (tag) => {
  const url = `${process.env.REACT_APP_API_URL}/tags/${tag.id}`;
  const headers = {
    'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
    'Content-Type': 'application/json'
  };
  try {
    const response = await axios.delete(url,{headers: headers});
    return response;
  } catch (error) {
    const {response} = error;
    return response;
  }
}


